<template>
  <div>
    <!-- <v-layout row
              v-if="!isLogged"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning">
              {{ $t('reservation.error.user.not.actived') }}
            </advice>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent"
                   round
                   outline
                   class="initialize white--text mr-4"
                   :to="{path:$t('urlRegister')}">
              {{$t('reservation.button.finishRegister')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout> -->

    <v-layout row
              v-if="isNonActiveUser"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning">
              {{ $t('reservation.error.user.not.actived') }}
            </advice>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent"
                   round
                   outline
                   class="initialize white--text mr-4"
                   :to="{path:$t('urlRegister')}">
              {{$t('reservation.button.finishRegister')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              v-else-if="noTags"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning">
              {{ $t('reservation.error.user.not.actived.tags') }}
            </advice>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent"
                   round
                   outline
                   class="initialize white--text mr-4"
                   :to="{path:$t('urlTeletac')}">
              {{$t('reservation.button.activateTag')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              v-else-if="noBalance"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning">
              {{ $t('reservation.error.user.not.balanced') }}
            </advice>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent"
                   round
                   outline
                   class="initialize white--text mr-4"
                   :to="{path:$t('urlBuy')}">
              {{$t('reservation.button.buy')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import store from '@/store';
import userService from '../../services/userService';
import Advice from '@/components/commons/Advice';

export default {
  name: 'UserNonAvailable',
  components: {
    [Advice.name]: Advice
  },
  computed: {
    isLogged() {
      return store.state.isLogged
    },
    isNonActiveUser() {
      return !userService.isActived()
    },
    noBalance() {
      return !(this.isLogged && !userService.hadBalance())
    },
    noTags() {
      return !(this.isLogged && !userService.hadActiveTags())
    }
  },
  data() {
    return {
    };
  }
};
</script>
